import React from 'react';

const DakshinaPricingControl = ({
  min,
  max,
  step,
  value,
  onChange,
  formatPrice,
  platformFeeNote,
  variant = 'default'
}) => {
  const safeMin = Number(min || 0);
  const safeMax = Number(max || safeMin);
  const safeStep = Number(step || 1);
  const safeValue = Number(value || safeMin);
  const isCompact = variant === 'compact';

  const containerClasses = isCompact
    ? 'mb-4 rounded-lg border border-amber-200 bg-amber-50 p-3'
    : 'mb-6 rounded-xl border border-amber-200 bg-amber-50 p-4';

  const titleClasses = isCompact
    ? 'mb-1 text-sm font-semibold text-amber-900'
    : 'mb-2 text-base font-semibold text-amber-900';

  const descriptionClasses = isCompact
    ? 'mb-2 text-xs text-amber-800'
    : 'mb-3 text-sm text-amber-800';

  const valueRowClasses = isCompact
    ? 'mt-2 flex justify-between text-xs text-amber-700'
    : 'mt-2 flex justify-between text-xs text-amber-700';

  return (
    <div className={containerClasses}>
      <h4 className={titleClasses}>Customize Dakshina Amount</h4>
      <p className={descriptionClasses}>
        Slide to choose dakshina between {formatPrice(safeMin)} and {formatPrice(safeMax)}.
      </p>

      <input
        type="range"
        min={safeMin}
        max={safeMax}
        step={safeStep}
        value={safeValue}
        onChange={(event) => onChange && onChange(Number(event.target.value))}
        className="w-full accent-rose-600"
      />

      <div className={valueRowClasses}>
        <span>{formatPrice(safeMin)}</span>
        <span className="font-semibold text-amber-900">Selected: {formatPrice(safeValue)}</span>
        <span>{formatPrice(safeMax)}</span>
      </div>

      {platformFeeNote && (
        <p className="mt-3 text-xs text-amber-700">
          {platformFeeNote}
        </p>
      )}
    </div>
  );
};

export default DakshinaPricingControl;
